import types from '../types/terms'

const disableButtonBeforeScroll = false

const initialRoot = {
  code: '',
  loadingTerms: true,
  loadingAccept: false,
  accepted: false,
  disabledButton: disableButtonBeforeScroll,
  acceptedTC: false,
  acceptedPrivacy: false,
  errorTerms: '',
  error: ''
}

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.VERIFY_ACCEPTANCE:
      return {
        ...state,
        code: action.payload.code,
        loadingTerms: true,
        errorTerms: '',
      }
    case types.VERIFY_ACCEPTANCE_SUCCESS:
      return {
        ...state,
        accepted: action.payload.accepted,
        loadingTerms: false,
      }
    case types.VERIFY_ACCEPTANCE_FAIL:
      return {
        ...state,
        loadingTerms: false,
        errorTerms: action.payload.error,
      }
    case types.ACCEPT_TC:
      return {...state, acceptedTC: true, disabledButton: disableButtonBeforeScroll}
    case types.ENABLE_ACCEPT_BUTTON:
      return {...state, disabledButton: false}
    case types.ACCEPT_PRIVACY:
      return {
        ...state,
        loadingAccept: true,
        error: '',
      }
    case types.ACCEPT_PRIVACY_SUCCESS:
      return {
        ...state,
        acceptedPrivacy: true,
        loadingAccept: false,
      }
    case types.ACCEPT_PRIVACY_FAIL:
      return {
        ...state,
        loadingAccept: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/terms/reducers/terms.js